class Notice {

  static play_key = 'isPlay'

  static openNotice() {
    window.localStorage.setItem('isPlay', "true");
  }

  static closeNotice() {
    window.localStorage.setItem('isPlay', "false");
  }

}

export {
  Notice
}
